import { createInvokeEpic } from '../../signalr/createInvokeEpic'
import { fetchBooksDefinition } from './definition'

export default createInvokeEpic('books.fetchBooks', fetchBooksDefinition)
